<template>
  <div v-if="show" class="content_item_tip_box" :class="[$store.state.isMirroring && 'mirror']">
    <p>{{ content }}</p>
    <img
      :src="noticeImg || require('@/assets/linkAccount/notice.png')"
      class="notice_img"
      :class="[$store.state.isMirroring && 'mirror']"
      alt=""
    />
    <img
      v-if="clearable"
      src="@/assets/linkAccount/note_close.png"
      class="note_close_img"
      :class="[$store.state.isMirroring && 'mirror']"
      alt=""
      @click="show = false"
    />
  </div>
</template>
<script>
export default {
  name: 'Tip',
  props: {
    content: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
    noticeImg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: true
    }
  }
}
</script>
<style scoped>
.content_item_tip_box {
  margin: 0.12rem 0;
  position: relative;
  height: 0.48rem;
  font-size: 0.1rem;
  color: #ff840b;
  padding: 0.06rem 0.14rem;
  text-align: start;
  border-radius: 0.08rem;
  border: 0.005rem solid rgba(255, 132, 11, 0.4);
  background: rgba(255, 199, 20, 0.1);
  line-height: 0.18rem;
  z-index: 2;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.content_item_tip.mirror {
  text-align: right;
}

.notice_img {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0.34rem;
  height: 0.34rem;
  flex-shrink: 0;
  z-index: -1;
}

.notice_img.mirror {
  left: 0;
  right: auto;
}

.note_close_img {
  position: absolute;
  top: 0;
  right: 0;
  width: 0.16rem;
  height: 0.16rem;
  gap: 0.1rem;
  z-index: 2;
}

.note_close_img.mirror {
  left: 0;
  right: auto;
  transform: rotate(90deg);
}

.notice_img.mirror {
  position: absolute;
  left: 0.02rem;
  right: auto;
  bottom: -0.06rem;
  transform: rotate(70deg);
}
</style>



// WEBPACK FOOTER //
// src/components/LinkAccount/Tip.vue